"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoIcon = void 0;
exports.TitleGalleryFormItemLabel = TitleGalleryFormItemLabel;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_1 = require("@ant-design/icons");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const styled_components_1 = __importDefault(require("styled-components"));
exports.InfoIcon = (0, styled_components_1.default)(icons_1.InfoCircleOutlined) `
	color: ${props => props.theme.color.brand2};
	cursor: pointer;
	font-size: 1rem;
	margin-left: 0.5rem;
`;
const LabelAndInfoIconContainer = styled_components_1.default.div `
	display: flex;
	align-items: center;
`;
function TitleGalleryFormItemLabel({ onClick }) {
    return ((0, jsx_runtime_1.jsxs)(LabelAndInfoIconContainer, { children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.offer.assets.gallery_form.is_title_gallery.label" }), (0, jsx_runtime_1.jsx)(exports.InfoIcon, { onClick: onClick })] }));
}
